export default function ToolConfigTable({ tools, toolConfig, onToggleEnabled, onToggleForced }) {
  return (
    <div className="tool-config-table">
      <div className="tool-config-header">
        <span className="tool-config-col-tool">Tool</span>
        <span className="tool-config-col-toggle">Enabled</span>
        <span className="tool-config-col-toggle">Forced</span>
      </div>
      {tools.map(tool => {
        const cfg = toolConfig[tool.name] ?? { enabled: true, forced: false };
        return (
          <div key={tool.name} className={`tool-config-row ${!cfg.enabled ? 'tool-config-row--disabled' : ''}`}>
            <div className="tool-config-col-tool">
              <span className="tool-config-name">{tool.label}</span>
              <span className="tool-config-hint">{tool.hint}</span>
            </div>
            <div className="tool-config-col-toggle">
              <button
                type="button"
                role="switch"
                aria-checked={cfg.enabled}
                className={`toggle-switch toggle-switch--sm ${cfg.enabled ? 'toggle-on' : ''}`}
                onClick={() => onToggleEnabled(tool.name)}
              >
                <span className="toggle-thumb" />
              </button>
            </div>
            <div className="tool-config-col-toggle">
              <button
                type="button"
                role="switch"
                aria-checked={cfg.forced}
                className={`toggle-switch toggle-switch--sm ${cfg.forced ? 'toggle-on toggle-on--forced' : ''}`}
                onClick={() => onToggleForced(tool.name)}
                disabled={!cfg.enabled}
                title={!cfg.enabled ? 'Enable the tool first' : cfg.forced ? 'Forced on round 0' : 'Force this tool on round 0'}
              >
                <span className="toggle-thumb" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
